import useSWR, { SWRConfiguration, SWRResponse } from "swr";
import { fetchAllV1Items, fetchV1PageItems, v1PageUrl } from "~/utils/accessController";
import { safelyCamelize } from "~/utils/object";

interface UseV1ListOptions<T> extends SWRConfiguration<T[]> {
  shouldCamelize?: boolean;
  // When set, fetch a single page of at most this many items instead of paging
  // through the whole result set. For pickers that only render a short list.
  pageLimit?: number;
}

// SWR hook that returns every item from a v1 list endpoint, with optional camelize for
// resources whose items arrive snake_case on the wire (funding sources)
export const useV1List = <T>(
  url: string | null,
  options: UseV1ListOptions<T> = {}
): SWRResponse<T[]> => {
  const { shouldCamelize, pageLimit, ...swrOptions } = options;
  // Bake the bound into the URL so distinct limits get distinct cache entries.
  const key = url !== null && pageLimit !== undefined ? v1PageUrl(url, pageLimit) : url;
  return useSWR<T[]>(
    key,
    async (listUrl: string) => {
      const items =
        pageLimit !== undefined
          ? await fetchV1PageItems<T>(listUrl)
          : await fetchAllV1Items<T>(listUrl);
      return shouldCamelize ? safelyCamelize(items, false) : items;
    },
    swrOptions
  );
};
